import React from 'react';
import PropTypes from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import SocialSharing from '../shared/SocialSharing';
import TopPanel from '../shared/TopPanel';
import SafePureComponent from '../shared/SafePureComponent';

import './style.scss';

const ShareYourGig = (props, context) => {
    const { requestContext, general } = context;
    const { gigId, gigTitle }  = general;
    const { params } = requestContext;
    const { username } = params;

    return (
        <TopPanel customClass="share-your-gig">
            <header>
                <h2><I18n k={'gig_page_perseus.share_your_gig.reach'}/></h2>
                <p><I18n k={'gig_page_perseus.share_your_gig.you_got'}/></p>
            </header>
            <SocialSharing gigId={gigId}
                gigTitle={gigTitle}
                sellerName={username}
                isPageOwner={true}
                title={<I18n k="gig_page_perseus.share_your_gig.button_text"/>}
                customClass="btn-lrg-standard"/>
        </TopPanel>
    );
};

ShareYourGig.contextTypes = {
    general: PropTypes.object,
    requestContext: PropTypes.object
};

export { ShareYourGig };
export default SafePureComponent(ShareYourGig);
